import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex flex-fill justify-content-center"
}
const _hoisted_2 = {
  class: "",
  style: {"max-width":"800px"}
}
const _hoisted_3 = { class: "text-center fs-1 fw-bold mb-3" }
const _hoisted_4 = {
  class: "card card-body bg-light align-self-center p-5 mb-0",
  style: {"max-width":"800px"}
}
const _hoisted_5 = { class: "row mb-sm-2" }
const _hoisted_6 = { class: "col-sm-8" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  class: "ps-5 pe-5",
  style: {"max-width":"800px"}
}
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_11 = { class: "d-flex" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "card card-body p-5 mt-4" }
const _hoisted_14 = { class: "fs-3" }
const _hoisted_15 = { class: "mt-4" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 1,
  class: "mt-2 d-flex flex-fill justify-content-center"
}
const _hoisted_21 = {
  class: "",
  style: {"max-width":"800px"}
}
const _hoisted_22 = { class: "text-center fs-1 fw-bold mb-3" }
const _hoisted_23 = { class: "card card-body p-5 mt-4" }
const _hoisted_24 = { class: "text-navy" }
const _hoisted_25 = {
  class: "mt-3",
  style: {"max-width":"800px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.sendDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "img-fluid"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-4 mb-4 text-center" }, [
              _createElementVNode("div", { class: "d-inline-block text-start" }, [
                _createTextVNode(" Webユーザー登録されているメールアドレスを入力してください。"),
                _createElementVNode("br"),
                _createTextVNode(" パスワード再設定に必要な情報を送信します。 ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label col-sm-4" }, "メールアドレス", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateCanSend && _ctx.updateCanSend(...args))),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mailAddress) = $event)),
                    class: "form-control form-control-lg"
                  }, null, 544), [
                    [_vModelText, _ctx.mailAddress]
                  ]),
                  (!_ctx.canSendResult && _ctx.mailAddress.length>0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.mailMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      ref: "sendButton",
                      class: "btn btn-lg btn-primary text-white flex-fill",
                      disabled: !_ctx.canSendResult,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendResetPasswordMail()))
                    }, [
                      _createVNode(_component_fa, {
                        class: "me-1",
                        icon: "envelope"
                      }),
                      _cache[5] || (_cache[5] = _createTextVNode("送信する", -1))
                    ], 8, _hoisted_12)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fw-bold" }, "メール受信許可設定のお願い", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "携帯会社（通信回線事業者）のメールをご利用の方は下記ドメインからのメール受信許可の設定をお願いいたします。", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.configs['mail_domain']), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "fw-bold" }, "設定方法については下記の携帯会社サイトをご参照ください。", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.configs['keitai_kaisha_docomo'],
                      target: "_blank"
                    }, "NTTドコモ 受信リスト／拒否リスト設定", 8, _hoisted_16)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.configs['keitai_kaisha_au'],
                      target: "_blank"
                    }, "au(KDDI) 受信リスト設定", 8, _hoisted_17)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.configs['keitai_kaisha_softbank'],
                      target: "_blank"
                    }, "ソフトバンク 受信許可リスト設定", 8, _hoisted_18)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: _ctx.configs['keitai_kaisha_rakuten'],
                      target: "_blank"
                    }, "楽天モバイル 受信リスト／拒否リストの設定・変更・削除（楽メール）", 8, _hoisted_19)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.sendDone)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-center" }, [
              _createElementVNode("img", {
                src: _imports_0,
                class: "img-fluid"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, [
                  _cache[14] || (_cache[14] = _createTextVNode("パスワード再設定に必要な情報を 「", -1)),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.mailTemplate.mailTitle), 1),
                  _cache[15] || (_cache[15] = _createTextVNode("」という件名でメールをお送りしました。メールに記載されているURLにアクセスしてパスワードの再設定を行ってください。", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode("URLの有効期限は約" + _toDisplayString(_ctx.FormatUtils.minituesToHour(_ctx.configs['pwset_url_kigen'])) + "です。 ", 1)
                ]),
                _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
                _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                  _createTextVNode("●メールが届かない場合は下記の可能性があります。"),
                  _createElementVNode("br"),
                  _createTextVNode(" ・入力されたメールアドレスが登録されている内容と異なる。"),
                  _createElementVNode("br"),
                  _createTextVNode(" ・メール受信許可の設定がされていない。 ")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                ref: "sendButton",
                class: "btn btn-lg btn-primary text-white",
                style: {"width":"200px"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendDone=false))
              }, [
                _createVNode(_component_fa, {
                  class: "me-1",
                  icon: "rotate-left"
                }),
                _cache[20] || (_cache[20] = _createTextVNode("再入力", -1))
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}